import React, { Component } from 'react';
import './test.css';
import { Step, Button, Menu, Icon, Popup } from 'semantic-ui-react'
import { Landing } from './landing'
import Testone from './testpages/testone'
import Testtwo from './testpages/testtwo'
import Testthree from './testpages/testthree'
import Testfour from './testpages/testfour'
import Testfive from './testpages/testfive'
import Testsix from './testpages/testsix'
import Testfinal from './testpages/testfinal'
import { Scorecard } from '../components/scorecard'
import Failed from '../components/Failed'
import Passed from '../components/Passed'

class chart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFinalTest: false,
      activeStep: 'landing',
      correctEntries: [0, 0, 0],
      totalEntries: [0, 0, 0],
      totalErrorEntries: [0, 0, 0],
      individualTests: {testOne: [0, 0, 0], testTwo: [0, 0, 0], testThree: [0, 0, 0], testFour: [0, 0, 0], testFive: [0, 0, 0], testSix: [0, 0, 0], finalTest: [0, 0, 0]},
      showHelpVideo: [false, false, false, false, false],
      totalErrorsAllowed: 15,
      canGoToNextTest: false,
      username: '',
      testStepsUnlock: [false, false, false, false, false, false],
      hasLoadedTest: [false, false, false, false, false, false, false],
      passedFinalTest: false,
      failedFinalTest: false
    }
  }

  getCookie = (name) => {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  failedOrPassedFinalTest = (passFail) => {
    if (passFail) {
      this.setState({passedFinalTest: true, failedFinalTest: false})
    } else {
      this.setState({failedFinalTest: true, passedFinalTest: false})
    }
  }

  componentDidMount() {
    var isAuth = false;
    var loggedIn = this.getCookie("loggedIn")
    var hasFailed = this.getCookie("hasFailed")
    var hasPassed = this.getCookie("hasPassed")
    
    if (loggedIn && !hasFailed) isAuth = true;

    if (hasPassed) this.setState({passedFinalTest: true})

    if (!isAuth) document.location.href = "/"

    var username = this.getCookie("loggedInUser")
    this.setState({username: username})
  }

  changeLoadedTest = (testNumber) => {
    let hasLoadedTest = this.state.hasLoadedTest
    hasLoadedTest[testNumber - 1] = true
    this.setState({hasLoadedTest: hasLoadedTest})
  }

  testPorgressToNextTest = () => {
    const {totalEntries, activeStep} = this.state
    if (activeStep === "test-1") {
      if ((totalEntries[0] + totalEntries[1] + totalEntries[2]) > 18) {
        this.setState({canGoToNextTest: true})
      }
    } else if (activeStep === "test-2") {
      if ((totalEntries[0] + totalEntries[1] + totalEntries[2]) > 36) {
        this.setState({canGoToNextTest: true})
      }
    } else if (activeStep === "test-3") {
      if ((totalEntries[0] + totalEntries[1] + totalEntries[2]) > 54) {
        this.setState({canGoToNextTest: true})
      }
    } else if (activeStep === "test-4") {
      if ((totalEntries[0] + totalEntries[1] + totalEntries[2]) > 69) {
        this.setState({canGoToNextTest: true})
      }
    } else if (activeStep === "test-5") {
      if ((totalEntries[0] + totalEntries[1] + totalEntries[2]) > 84) {
        this.setState({canGoToNextTest: true})
      }
    }
  }

  landingContinue = () => {
    this.setState({activeStep: 'test-1'})
  }

  tempClosePopup = () => {this.setState({tempOpenPopup: false})}

  changeStep = (e) => {
    this.setState({activeStep: e.target.id, canGoToNextTest: false})
    this.forceUpdate()
  }

  ProgressToNextTest = () => {
    var step = this.state.activeStep
    var testStepsUnlock = this.state.testStepsUnlock

    switch(step) {
      case 'test-1':
        step = 'test-2'
        testStepsUnlock[0] = true
        break;
      case 'test-2':
        step = 'test-3'
        testStepsUnlock[1] = true
        break;
      case 'test-3':
        step = 'test-4'
        testStepsUnlock[2] = true
        break;
      case 'test-4':
        step = 'test-5'
        testStepsUnlock[3] = true
        break;
      case 'test-5':
        step = 'test-6'
        testStepsUnlock[4] = true
        break;
      case 'test-6':
        step = 'final-test'
        testStepsUnlock[5] = true
        break;
    }
    this.forceUpdate()
    this.setState({canGoToNextTest: false, testStepsUnlock: testStepsUnlock, activeStep: step})
  }

  incrementFinalTest = (Ind) => {
    var individualTests = this.state.individualTests
    individualTests.finalTest[Ind] = individualTests.finalTest[Ind] + 1
    this.setState({individualTests: individualTests});
  }

  incrementEntries = (itemError, wholesaleError, asinError, totalIncrement) => {
    var correctEntries = this.state.correctEntries
    var totalEntries = this.state.totalEntries
    var totalErrorEntries = this.state.totalErrorEntries
    var activeStep = this.state.activeStep
    var testStepsUnlock = this.state.testStepsUnlock
    var individualTests = this.state.individualTests
    var i

    if (totalIncrement) {
      for (i = 0; i < totalEntries.length; i++){
        totalEntries[i] = totalEntries[i] + 1;
      }  
    }

    if (itemError === true) {
      totalErrorEntries[0] = totalErrorEntries[0] + 1
      if (activeStep === "test-1") {
        individualTests.testOne[0] = individualTests.testOne[0] + 1
      }
      if (activeStep === "test-2") {
        individualTests.testTwo[0] = individualTests.testTwo[0] + 1
      }
      if (activeStep === "test-3") {
        individualTests.testThree[0] = individualTests.testThree[0] + 1
      }
      if (activeStep === "test-4") {
        individualTests.testFour[0] = individualTests.testFour[0] + 1
      }
      if (activeStep === "test-5") {
        individualTests.testFive[0] = individualTests.testFive[0] + 1
      }
      if (activeStep === "test-6") {
        individualTests.testSix[0] = individualTests.testSix[0] + 1
      }
    } else if (itemError === false) {
      correctEntries[0] = correctEntries[0] + 1
      
    }

    if (wholesaleError === true) {
      totalErrorEntries[1] = totalErrorEntries[1] + 1
      if (activeStep === "test-1") {
        individualTests.testOne[1] = individualTests.testOne[1] + 1
      }
      if (activeStep === "test-2") {
        individualTests.testTwo[1] = individualTests.testTwo[1] + 1
      }
      if (activeStep === "test-3") {
        individualTests.testThree[1] = individualTests.testThree[1] + 1
      }
      if (activeStep === "test-4") {
        individualTests.testFour[1] = individualTests.testFour[1] + 1
      }
      if (activeStep === "test-5") {
        individualTests.testFive[1] = individualTests.testFive[1] + 1
      }
      if (activeStep === "test-6") {
        individualTests.testSix[1] = individualTests.testSix[1] + 1
      }
    } else if (wholesaleError === false) {
      correctEntries[1] = correctEntries[1] + 1
      
    }

    if (asinError === true) {
      totalErrorEntries[2] = totalErrorEntries[2] + 1
      if (activeStep === "test-1") {
        individualTests.testOne[2] = individualTests.testOne[2] + 1
      }
      if (activeStep === "test-2") {
        individualTests.testTwo[2] = individualTests.testTwo[2] + 1
      }
      if (activeStep === "test-3") {
        individualTests.testThree[2] = individualTests.testThree[2] + 1
      }
      if (activeStep === "test-4") {
        individualTests.testFour[2] = individualTests.testFour[2] + 1
      }
      if (activeStep === "test-5") {
        individualTests.testFive[2] = individualTests.testFive[2] + 1
      }
      if (activeStep === "test-6") {
        individualTests.testSix[2] = individualTests.testSix[2] + 1
      }
    } else if (asinError === false) {
      correctEntries[2] = correctEntries[2] + 1
      
    }

    if (activeStep === "test-1") {
      if ((totalEntries[0] + totalEntries[1] + totalEntries[2]) === 18) {
        this.setState({canGoToNextTest: true})
        testStepsUnlock[0] = true
      }
    } else if (activeStep === "test-2") {
      if ((totalEntries[0] + totalEntries[1] + totalEntries[2]) === 36) {
        this.setState({canGoToNextTest: true})
        testStepsUnlock[1] = true
      }
    } else if (activeStep === "test-3") {
      if ((totalEntries[0] + totalEntries[1] + totalEntries[2]) === 54) {
        this.setState({canGoToNextTest: true})
        testStepsUnlock[2] = true
      }
    } else if (activeStep === "test-4") {
      if ((totalEntries[0] + totalEntries[1] + totalEntries[2]) === 69) {
        this.setState({canGoToNextTest: true})
        testStepsUnlock[3] = true
      }
    } else if (activeStep === "test-5") {
      if ((totalEntries[0] + totalEntries[1] + totalEntries[2]) === 84) {
        this.setState({canGoToNextTest: true})
        testStepsUnlock[4] = true
      }
    } else if (activeStep === "test-6") {
      if ((totalEntries[0] + totalEntries[1] + totalEntries[2]) === 102) {
        testStepsUnlock[5] = true
      }
    } else if (activeStep === "final-test") { //this is going to change based on what happens when they pass
      if ((totalEntries[0] + totalEntries[1] + totalEntries[2]) === 202) {
        this.setState({canGoToNextTest: true})
      }
    }

    if ((correctEntries[0] + correctEntries[1] + correctEntries[2]) === 102) { this.setState({showFinalTest: true, canGoToNextTest: true}) }

    this.setState({totalEntries: totalEntries, totalErrorEntries: totalErrorEntries, correctEntries: correctEntries, testStepsUnlock: testStepsUnlock, individualTests: individualTests})
  }  

  render() {
    const { showFinalTest, activeStep, correctEntries, totalEntries, totalErrorEntries, 
      totalErrorsAllowed, canGoToNextTest, username, testStepsUnlock, passedFinalTest, failedFinalTest} = this.state

    var menuBarStyle = {
      position: 'fixed', bottom: '0', width: '100%', borderRadius: '0', background: '#cecece'
    }

    if (showFinalTest) {
      var finalTestStep = <Step id="final-test" onClick={this.changeStep} active={activeStep === "final-test"}>
              <Step.Content>
                <Step.Title id="final-test" onClick={this.changeStep}>Final Test</Step.Title>
              </Step.Content>
            </Step>;
    } else {
      var finalTestStep //eslint-disable-line
    }

    if (activeStep !== "landing") {
      var scoreCard = <Scorecard correctEntries={correctEntries} 
        totalEntries={totalEntries} 
        totalErrorEntries={totalErrorEntries}
        totalErrorsAllowed={totalErrorsAllowed} />

      var bottomBar = 
        <Menu style={menuBarStyle}>
          <Menu.Menu position='right'>
            <Button animated primary disabled={!canGoToNextTest} style={{borderRadius: '0'}} onClick={this.ProgressToNextTest} >
              <Button.Content visible>Next Test</Button.Content>
              <Button.Content hidden>
                <Icon name='right arrow' />
              </Button.Content>
            </Button>
          </Menu.Menu>
        </Menu>;

      var popUpTable = <Popup
          trigger={<div style={{position: 'absolute', bottom: '7%', right: '1%'}}><Icon circular size={"large"} name="angle up"/></div>}
          flowing
          hoverable
        >{scoreCard}</Popup>;

    } else {var scoreCard; var bottomBar; var popUpTable;} //eslint-disable-line

    /* eslint-disable */
    if (testStepsUnlock[0]) { 
      var stepTwoActive = <Step id="test-2" onClick={this.changeStep} active={activeStep === "test-2"}>
              <Step.Content>
                <Step.Title id="test-2" onClick={this.changeStep}>Test 2</Step.Title>
              </Step.Content>
            </Step>;
    } else {
      var stepTwoActive = <Step active={activeStep === "test-2"}>
              <Step.Content>
                <Step.Title>Test 2</Step.Title>
              </Step.Content>
            </Step>;
    }

    if (testStepsUnlock[1]) {
      var stepThreeActive =  <Step id="test-3" onClick={this.changeStep} active={activeStep === "test-3"}>
              <Step.Content>
                <Step.Title id="test-3" onClick={this.changeStep}>Test 3</Step.Title>
              </Step.Content>
            </Step>;
    } else {
      var stepThreeActive = <Step active={activeStep === "test-3"}>
              <Step.Content>
                <Step.Title>Test 3</Step.Title>
              </Step.Content>
            </Step>;
    }

    if (testStepsUnlock[2]) {
      var stepFourActive =  <Step id="test-4" onClick={this.changeStep} active={activeStep === "test-4"}>
              <Step.Content>
                <Step.Title id="test-4" onClick={this.changeStep}>Test 4</Step.Title>
              </Step.Content>
            </Step>;
    } else {
      var stepFourActive = <Step active={activeStep === "test-4"}>
              <Step.Content>
                <Step.Title>Test 4</Step.Title>
              </Step.Content>
            </Step>;
    }

    if (testStepsUnlock[3]) {
      var stepFiveActive = <Step id="test-5" onClick={this.changeStep} active={activeStep === "test-5"}>
              <Step.Content>
                <Step.Title id="test-5" onClick={this.changeStep}>Test 5</Step.Title>
              </Step.Content>
            </Step>;
    } else {
      var stepFiveActive = <Step active={activeStep === "test-5"}>
              <Step.Content>
                <Step.Title>Test 5</Step.Title>
              </Step.Content>
            </Step>;
    }

    if (testStepsUnlock[4]) {
      var stepSixActive = <Step id="test-6" onClick={this.changeStep} active={activeStep === "test-6"}>
              <Step.Content>
                <Step.Title id="test-6" onClick={this.changeStep}>Test 6</Step.Title>
              </Step.Content>
            </Step>;
    } else {
      var stepSixActive = <Step active={activeStep === "test-6"}>
              <Step.Content>
                <Step.Title>Test 6</Step.Title>
              </Step.Content>
            </Step>;
    }


    switch(activeStep) {
      case 'test-1':
        var activeTests = <Testone 
          testPorgressToNextTest={this.testPorgressToNextTest} 
          landingContinue={this.landingContinue} 
          incrementEntries={this.incrementEntries} 
          getCookie={this.getCookie} 
          hasLoadedTest={this.state.hasLoadedTest}
          changeLoadedTest={this.changeLoadedTest}
        />;
        break;
      case 'test-2':
        var activeTests = <Testtwo 
          testPorgressToNextTest={this.testPorgressToNextTest} 
          landingContinue={this.landingContinue} 
          incrementEntries={this.incrementEntries} 
          testStepsUnlock={this.state.testStepsUnlock}
          getCookie={this.getCookie} 
          hasLoadedTest={this.state.hasLoadedTest}
          changeLoadedTest={this.changeLoadedTest}
        />;
        break;
      case 'test-3':
        var activeTests = <Testthree 
          testPorgressToNextTest={this.testPorgressToNextTest} 
          landingContinue={this.landingContinue} 
          incrementEntries={this.incrementEntries} 
          testStepsUnlock={this.state.testStepsUnlock}
          getCookie={this.getCookie} 
          hasLoadedTest={this.state.hasLoadedTest}
          changeLoadedTest={this.changeLoadedTest}
        />;
        break;
      case 'test-4':
        var activeTests = <Testfour 
          testPorgressToNextTest={this.testPorgressToNextTest} 
          landingContinue={this.landingContinue} 
          incrementEntries={this.incrementEntries} 
          testStepsUnlock={this.state.testStepsUnlock}
          getCookie={this.getCookie} 
          hasLoadedTest={this.state.hasLoadedTest}
          changeLoadedTest={this.changeLoadedTest}
        />;
        break;
      case 'test-5':
        var activeTests = <Testfive 
          testPorgressToNextTest={this.testPorgressToNextTest} 
          landingContinue={this.landingContinue} 
          incrementEntries={this.incrementEntries} 
          testStepsUnlock={this.state.testStepsUnlock}
          getCookie={this.getCookie} 
          hasLoadedTest={this.state.hasLoadedTest}
          changeLoadedTest={this.changeLoadedTest}
        />;
        break;
      case 'test-6':
        var activeTests = <Testsix 
          testPorgressToNextTest={this.testPorgressToNextTest} 
          landingContinue={this.landingContinue} 
          incrementEntries={this.incrementEntries} 
          testStepsUnlock={this.state.testStepsUnlock}
          getCookie={this.getCookie} 
          hasLoadedTest={this.state.hasLoadedTest}
          changeLoadedTest={this.changeLoadedTest}
        />;
        break;
      case 'final-test':
        var activeTests = <Testfinal 
          testPorgressToNextTest={this.testPorgressToNextTest} 
          landingContinue={this.landingContinue} 
          incrementEntries={this.state.incrementEntries} 
          getCookie={this.getCookie} 
          hasLoadedTest={this.state.hasLoadedTest}
          changeLoadedTest={this.changeLoadedTest}
          failedOrPassedFinalTest={this.failedOrPassedFinalTest}
          incrementFinalTest={this.incrementFinalTest}
        />;
        var popUpTable = ""
        break;
    }

    /* eslint-enable */

    var hasFailedOrPassed = <div style={{overflowY: 'auto'}}>
        <div style={{marginLeft: '10px', marginRight: '10px'}}>
          <Step.Group style={{width: '100%'}} >
            <Step id="landing" onClick={this.changeStep} active={activeStep === "landing"}>
              <Step.Content>
                <Step.Title id="landing" onClick={this.changeStep}>Landing</Step.Title>
              </Step.Content>
            </Step>
            <Step id="test-1" onClick={this.changeStep} active={activeStep === "test-1"}>
              <Step.Content>
                <Step.Title id="test-1" onClick={this.changeStep}>Test 1</Step.Title>
              </Step.Content>
            </Step>
            {stepTwoActive}
            {stepThreeActive}
            {stepFourActive}
            {stepFiveActive}
            {stepSixActive}
            {finalTestStep}
          </Step.Group>
        </div>
        {activeStep === "landing" ? <Landing landingContinue={this.landingContinue} /> : ""}
        {activeTests}
        {popUpTable}
        {bottomBar}
      </div>

    if ((totalErrorEntries[0] + totalErrorEntries[1] + totalErrorEntries[2]) >= 15 || failedFinalTest === true) {
      hasFailedOrPassed = <div style={{overflowY: 'auto'}}>
        <Failed getCookie={this.getCookie} 
          failedFinalTest={failedFinalTest} 
          correctEntries={correctEntries} 
          totalEntries={totalEntries} 
          totalErrorEntries={totalErrorEntries}
          individualTests={this.state.individualTests}
        />
      </div>
    } else if (passedFinalTest === true) {
      hasFailedOrPassed = <div style={{overflowY: 'auto'}}>
        <Passed getCookie={this.getCookie} 
          individualTests={this.state.individualTests}
        />
      </div>
    }
    


    return ( <div>
      {hasFailedOrPassed}
      </div>
    );
  }
}

export default chart;



// WEBPACK FOOTER //
// ./src/pages/Testmain.js